import apiClient from './apiClient';
import type { LLMUsageStats, LLMUsageLogsResponse } from '@/types';

const apiBaseURL = '/admin/llm-usage';

export interface LLMUsageStatsParams {
  date_from?: string;
  date_to?: string;
  organization_id?: string;
  user_id?: string;
}

export interface LLMUsageLogsParams {
  skip?: number;
  limit?: number;
  task?: string;
  user_id?: string;
  organization_id?: string;
  date_from?: string;
  date_to?: string;
}

export const llmUsageService = {
  getStats: async (params?: LLMUsageStatsParams): Promise<LLMUsageStats> => {
    const response = await apiClient.get<LLMUsageStats>(`${apiBaseURL}/stats`, { params });
    return response.data;
  },

  getLogs: async (params?: LLMUsageLogsParams): Promise<LLMUsageLogsResponse> => {
    const response = await apiClient.get<LLMUsageLogsResponse>(`${apiBaseURL}/logs`, { params });
    return response.data;
  },
};

export default llmUsageService;
